module.exports = __webpack_public_path__ + "static/media/image_not_found.95a48606.jfif";